import { atom } from 'recoil';

export const chatFloatingOpenState = atom<boolean>({
  key: 'chatFloatingOpenState',
  default: false,
});

